export default "__VITE_ASSET__5gk_vN9K__"